import { compact } from 'lodash';
import { DynamicSection, SectionTypes } from '@fiverr-private/ai_brief';
import { isLanguagesPair } from '@fiverr-private/dynamic_matching';
import { BriefClassificationResponse, MetadataQuestionType } from '../../../api';
import { appTranslate } from '../../../i18n';
import { isLanguagesPairValid } from './LanguagePairs/utils';
import { MetadataEditComponent, MetadataSectionContent, MetadataViewComponent } from './MetadataSection';

export * from './MetadataSection';
export * from './LanguagePairs/utils';

export const getMetadataSection = (briefClassification: BriefClassificationResponse): DynamicSection[] => {
    const metadataQuestions = briefClassification.static_data?.metadata_questions || [];
    const extractedMetadataRoot = briefClassification?.resolved_data?.metadata;

    return metadataQuestions
        ? compact(
              metadataQuestions.map(({ metadata_type }) => {
                  const didExtractAnswer = !!extractedMetadataRoot?.filters[metadata_type];
                  let extractedMetadataAnswers = extractedMetadataRoot?.filters[metadata_type] || [];
                  const metadataQuestionStaticData = metadataQuestions.find(
                      ({ metadata_type: enriched_metadata_type }: MetadataQuestionType) =>
                          enriched_metadata_type === metadata_type
                  );

                  if (
                      !metadataQuestionStaticData ||
                      (metadataQuestionStaticData.display_priority === 3 && !didExtractAnswer)
                  ) {
                      return null;
                  }

                  const isLanguagesPairType = isLanguagesPair(metadata_type);

                  const title = isLanguagesPairType
                      ? appTranslate('sections.language_pairs.title')
                      : metadataQuestionStaticData.display_name;

                  const enrichedMetadataAnswers = metadataQuestionStaticData?.answers || [];

                  // Validate Language pair metadata
                  if (isLanguagesPairType) {
                      extractedMetadataAnswers = isLanguagesPairValid(extractedMetadataAnswers)
                          ? extractedMetadataAnswers
                          : [];
                  }

                  const metadataSectionContent: MetadataSectionContent = {
                      selectedAnswers: extractedMetadataAnswers,
                      allAnswers: enrichedMetadataAnswers,
                      question: metadataQuestionStaticData,
                  };

                  if (!metadataSectionContent) {
                      return null;
                  }

                  const isMandatory = metadataQuestionStaticData.display_priority === 1;
                  const isIncluded = isMandatory || didExtractAnswer;

                  return {
                      id: `metadata_${metadata_type}`,
                      title,
                      mandatory: isMandatory,
                      content: metadataSectionContent.selectedAnswers,
                      included: isIncluded,
                      type: SectionTypes.metadata,
                      ViewComponent: MetadataViewComponent,
                      EditComponent: MetadataEditComponent,
                      metadata: metadataSectionContent,
                      hideActions: true,
                  };
              })
          )
        : [];
};
